import { ANALYZE_FOR_ENTRY_COMPONENTS, Component, OnInit } from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import {Angular2CsvModule} from 'angular2-csv';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
declare var getHexAscii: any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
@Component({
  selector: 'app-atm-card-request',
  templateUrl: './atm-card-request.component.html',
  styleUrls: ['./atm-card-request.component.css']
})
export class AtmCardRequestComponent implements OnInit {
  scAccounts: any [];
  accountInfo: any ;
  debitCardAcct : string = '';
  balance : string ='';
  selectedStopPayment : string ='';
  selectedBalance : string='';
  crr : string='';
  stopPaymentAcct : string='';
  selectedCurrencyCode : string='';
  isShow : string='page1';
  addressDetails :  any=[] ;
  debitCardAddress : any;
  transactionPin : string ='';
  error : string ='';
  cardCat : string ='';
  EmbossingName : string ='';
  otp : string ='';
  debitCardNumber ; any ;
  cardType : string ='';
  custmerInfo : any=[];
  addressDetailsarray : any=[];
  address1 : string = '';
  address2 : string = '';
  address3 : string = '';
  area : string = '';
  areaDesctiption : string = '';
  mobile : string = '';
  phone : string = '';
  city : string = '';
  pin : string = '';
  storedOtp : string ='';
  invalidOtp : string ='';
  EmbossnameSpeci:string='';
  EmbossnameNumbers:string='';
  Embossnamelength:string='';
  EmbossnameRequired:string='';
  accNoRequired:string='';
  cardCatRequired:string='';
  cardTypeRequired:string='';

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNumbers = /^.*[0-9]/;
  disableSub1Btn:boolean=false;
  OtpRequired:string='';
  disableSub2Btn:boolean=false;
  NameSpace : string ='';
  InvalidOTP : string ='';
  successMessage : string ='';
  isError1:boolean=false;
  otpError: string;
  regNumsOnly =/^\d+$/;

  debitCradTypes = [];
  debitCardCategory = [];

  private _jsonURL = 'assets/SampleUrl.json';

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService,
    private http : HttpClient) {
    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));

    this.getJSON().subscribe(data => {
      // console.log(' Sample Json in atm request class: '+JSON.stringify(data));
      this.debitCradTypes = data.debitCradTypes;
      this.debitCardCategory = data.debitCardCategory;
      console.log("selected array is "+this.debitCradTypes);
     // console.log('urlfromJson----:-'+this.urlfromJson);
     });

  }

  public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }


  getCustAddress()
  {

//  this.spinnerService.show();
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    if(this.debitCardAcct){
      // alert(this.debitCardAcct);
      // alert(this.cardCat);
      // alert(this.cardType);
      // alert(this.EmbossingName);


      console.log('Input : ' +getHexAscii("",this.debitCardAcct));

      request.param1 = getHexAscii("",this.debitCardAcct);
      request.param2 = this.debitCardAcct;
      //request.param5=this.addrType;
      this.webService.getResponse(request, 'customerAddressForEservice').subscribe((data: IbResponse) => {
        //  this.spinnerService.hide();
        this.debitCardAddress=data;
        // alert("debitCardAddress is:"+this.debitCardAddress);
        if (this.debitCardAddress.status === 'S101'){
          alert('Malicious Request Detected');
        }
        if(this.debitCardAddress.status==='S200'){
          // alert('Successfully');
          this.addressDetails= this.debitCardAddress.param6;
          // alert(" addressDetails is:"+ this.addressDetails);
          this.custmerInfo =this.debitCardAddress.param5;
          // alert(" custmerInfo is:"+ this.custmerInfo);
          // this.addressDetailsarray= this.debitCardAddress.param6;
          console.log('address' +  JSON.stringify(this.addressDetails) );
          for (const [key, value] of Object.entries(this.addressDetails)) {

            this.addressDetailsarray.push(key);
            console.log("come here  "+this.addressDetailsarray.add1);
          }
          console.log("cust info isss "+this.custmerInfo);
          //this.isShow='page2';
        }
      });
    }
  }

  validateOtp(){ 
    if(this.otp==='' || this.otp===' ' || this.otp===null || this.otp===undefined ){
      this.otpError='yes';
      return false;
    }else if(!this.otp.match(this.regNumsOnly)){
      this.otpError='nums';
      return false;
    }else{
      
    return true;
    }
  }


  submotFirst(){
    if (this.debitCardAcct === undefined||this.debitCardAcct ===''||this.debitCardAcct ==="  ") {
      this.accNoRequired = 'no';

    } else if (this.cardCat === undefined||this.cardCat ===''||this.cardCat ==="  ") {
      this.cardCatRequired = 'no';

    } else if (this.cardType === undefined||this.cardType ===''||this.cardType ==="  ") {
      this.cardTypeRequired = 'no';

    }else if (this.EmbossingName === undefined||this.EmbossingName ===''||this.EmbossingName ==="  ") {
      this.EmbossnameRequired = 'no';

    } else  if (this.EmbossingName.match(this.reg)) {
      this.EmbossnameSpeci = 'no';
    } else if (this.EmbossingName.length > 50) {
      this.Embossnamelength = 'no';

    }else  if (this.EmbossingName.match(this.regNumbers)) {
      this.EmbossnameNumbers = 'no';
    }
    else if (/^\s/.test(this.EmbossingName)) {

      this.NameSpace='no';

    }
    else{
      this.disableSub1Btn=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
      request.param2 =sessionStorage.getItem('custno');
      this.webService.getResponse(request, 'custno').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.isShow = 'page2';
          // this.storedOtp=response.param1;
        } else if (response !== null) {
         
          this.error = response.param1;
          this.disableSub1Btn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableSub1Btn=false;
        }
      });
    }
  }

  //generate OTP
  submotSecond(){
    // if (this.otp === undefined||this.otp ===''||this.otp ==="  ") {
    //   this.OtpRequired = 'no';

    // }else{
      if(this.validateOtp()){

      this.disableSub2Btn=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("address detail "+this.addressDetailsarray.add1+"city "+this.addressDetailsarray.cityDesc);
      const custAdd = {
        'add1': this.custmerInfo.add1,
        'add2': this.custmerInfo.add2,
        'add3': this.custmerInfo.add3,
        'city' :this.custmerInfo.city,
        'area': this.custmerInfo.area,
        'phoneNo':this.custmerInfo.phoneNo,
        'Mobile': this.custmerInfo.Mobile,
        'email':this.custmerInfo.EmailId,
        'pinCd': this.custmerInfo.pinCd,
        'debitCardAcct' : this.debitCardAcct,
        'cardCat' : this.cardCat,
        'cardType' :this.cardType,
        'EmbossingName' : this.EmbossingName,
        'dateOFBirth' : this.custmerInfo.dateofBirth,
        'nameTitle' : this.custmerInfo.nameTitle,
        'prdAcctid' : this.custmerInfo.prdAcctid,
        'brcode' : this.custmerInfo.brcode,
      };

      request.param2= getHexAscii('',this.otp);
      request.param3=sessionStorage.getItem("custNo");
      request.param1 = getHexAscii('', this.otp+request.param3+sessionStorage.getItem('storedUserName'));
      request.param4=sessionStorage.getItem('storedUserName');
      request.param5='';
      request.param6 = custAdd;

      this.webService.getResponse(request, 'atmRequest').subscribe((data: IbResponse) => {
         this.spinnerService.hide();
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          
            this.isShow = 'page2';
            this.invalidOtp='no';
  
            this.successMessage=response.param1;
            this.isShow = 'page3';
          
        }else if(data.status==='S333'){
           this.otpError='backendError';
           this.error=data.param1;
        }else if(data.status==='S334'){
          this.otpError='backendError';
          this.error=data.param1;
        }  else if (response !== null) {
           this.isError1=true;
          this.error = response.param1;
          this.disableSub2Btn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
         
        }
      });
      
    }
  }

  submotIOTP()
  {
  }
  ngOnInit() {
    $(document).ready(function() {
      $('input').bind('copy paste cut',function(e) { 
      e.preventDefault(); //disable cut,copy,paste
      });
     });
  }

  removeEmbNameMsgs()
  {
    /*this.debitCardAcct='';
    this.cardCat='';
    this.cardType='';*/
    this.EmbossingName='';
    this.EmbossnameSpeci='';
    this.EmbossnameNumbers='';
    this.Embossnamelength='';
    this.EmbossnameRequired='';
    this.NameSpace='';
  }
  removeCardTypeMsgs()
  {
    this.cardTypeRequired='';
   
  }
  removeCardCatMsgs()
  {
    
    this.cardCatRequired='';
   
    
  }
  removeAccMsgs()
  {
    this.accNoRequired='';
  }
  removeOtpMsgs()
  {
    this.disableSub2Btn=false;
    this.otpError='';
    this.OtpRequired='';
    this.invalidOtp='';
  
  }
  OK()
  {
    this.EmbossnameSpeci='';
    this.EmbossnameNumbers='';
    this.Embossnamelength='';
    this.EmbossnameRequired='';
    this.NameSpace='';
    this.otp='';
    this.disableSub1Btn=false;
    this.isShow='page1';

  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/atm-card-request/atm-card-request.component.ts